import { createContext } from "react";

// Mobile shell shared state — drawer open/close + helpers. The
// MobileShellProvider in App.jsx owns the state; consumers
// (MobileTopBar's hamburger, SidebarLayout's backdrop, individual
// nav items) read or call these via useMobileShell.
//
// Default value matches the closed-drawer no-op shape so any
// component that consumes the context outside the provider (e.g.
// during testing) renders without crashing.
export const MobileShellContext = createContext({
  isDrawerOpen: false,
  openDrawer: () => {},
  closeDrawer: () => {},
  toggleDrawer: () => {},
});
